class TestCategory {
  id = '';
  name = '';
  sort = 0;
  isArchived = true;

  /**
   * @param data
   */
  constructor(data) {
    for (const property of Object.keys(this)) {
      if (typeof data[property] === 'undefined') {
        throw new Error(`Property ${property} not set`);
      }

      if (typeof data[property] !== typeof this[property]) {
        throw new Error(
          `Invalid property ${typeof data[property]} type for ${property}`
        );
      }

      this[property] = data[property];
    }
  }
}

export default TestCategory;
